"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NucalmRequest = void 0;
var NucalmRequest = /** @class */ (function () {
    function NucalmRequest() {
    }
    return NucalmRequest;
}());
exports.NucalmRequest = NucalmRequest;
;
//# sourceMappingURL=nucalm.request.js.map